'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseModal = exports.PurchaseModalUnwrapped = exports.mapDispatchToProps = exports.CLASS_CARD = exports.OFFER_CARD = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _modals = require('redux/modules/modals');

var _multitrack = require('helpers/multitrack');

var _verify = require('helpers/verify');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _CardSelection = require('components/CardSelection');

var _ClassDetailCards = require('components/ClassDetailCards');

var _StarRating = require('components/StarRating/StarRating');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OFFER_CARD = exports.OFFER_CARD = 'offer';
var CLASS_CARD = exports.CLASS_CARD = 'class';

var mapDispatchToProps = exports.mapDispatchToProps = {
  updatePath: _reactRouterRedux.push,
  hideModal: _modals.hideModal
};

var PurchaseModalUnwrapped = exports.PurchaseModalUnwrapped = function (_Component) {
  (0, _inherits3.default)(PurchaseModalUnwrapped, _Component);

  function PurchaseModalUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, PurchaseModalUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = PurchaseModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(PurchaseModalUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.onModalClose = function () {
      (0, _multitrack.ga)('Membership Purchase', 'alc_checkout_selection_modal_close', _this.props.schedule.id);
    }, _this2.handleCardSelection = function (type) {
      var _this$props = _this.props,
          offer = _this$props.offer,
          schedule = _this$props.schedule,
          updatePath = _this$props.updatePath,
          hideModal = _this$props.hideModal;


      if (type === OFFER_CARD) {
        (0, _multitrack.ga)('Membership Purchase', 'alc_checkout_selection_modal_redeem_offer', schedule.id);
        updatePath('/signup/offer/' + _Base2.default.encode(offer.id));
      } else if (type === CLASS_CARD) {
        (0, _multitrack.ga)('Membership Purchase', 'alc_checkout_selection_modal_reserve_alc', schedule.id);
        updatePath('/signup/class/' + _Base2.default.encode(schedule.id));
      }

      hideModal('PurchaseModal');
    }, _this2.renderClassCard = function (_ref2) {
      var handleSelection = _ref2.handleSelection,
          selected = _ref2.selected;
      var schedule = _this.props.schedule;


      return _react2.default.createElement(
        _CardSelection.CalloutCard,
        {
          callout: _this.renderFormattedPrice(schedule.availability.purchase.amount, schedule.availability.purchase.currency),
          calloutNote: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'calloutCard.calloutNote',
            defaultMessage: 'for this class'
          }),
          ctaCopy: 'Reserve',
          extraClass: 'plan--cta-in-middle',
          details: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'calloutCard.details.singleClass',
            defaultMessage: 'Single class purchase'
          }),
          key: CLASS_CARD,
          onClick: handleSelection,
          selected: selected
        },
        _react2.default.createElement(
          _ClassDetailCards.ClassDetailCard,
          {
            extraClass: 'class-detail-card--large-class mt+',
            endTime: schedule.endtime,
            klassName: schedule.class.name,
            startTime: schedule.starttime,
            venueName: schedule.venue.name
          },
          !(0, _verify.isEmpty)(schedule.venue.ratings) && _react2.default.createElement(
            'div',
            { className: 'mhauto mt-' },
            _react2.default.createElement(_StarRating.StarRating, {
              rating: schedule.venue.ratings.mean,
              showRatingNumber: true
            })
          )
        )
      );
    }, _this2.renderOfferCard = function (_ref3) {
      var handleSelection = _ref3.handleSelection,
          selected = _ref3.selected;
      var offer = _this.props.offer;


      return offer && _react2.default.createElement(
        _CardSelection.CalloutCard,
        {
          callout: _this.renderFormattedPrice(offer.initial_plan.price, offer.msa.currency_code),
          calloutNote: offer.content && offer.content.card.price_terms,
          ctaCopy: offer.content ? offer.content.card.cta_copy : 'Redeem offer',
          extraClass: 'plan--cta-in-middle',
          details: _this.renderOfferCardDetails(),
          key: OFFER_CARD,
          onClick: handleSelection,
          selected: selected,
          tag: offer.content ? offer.content.card.tag : 'Best deal'
        },
        _react2.default.createElement(
          'div',
          { className: 'plan__details plan__details--checkmarks' },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              defaultMessage: 'Book this class and choose from thousands of others',
              id: 'modal.purchase.offer-card.offer-details.1',
              tagName: 'li'
            }),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              defaultMessage: 'Explore thousands of studios and gyms near you',
              id: 'modal.purchase.offer-card.offer-details.2',
              tagName: 'li'
            }),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              defaultMessage: 'Cancel or change your membership at any time',
              id: 'modal.purchase.offer-card.offer-details.3',
              tagName: 'li'
            })
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(PurchaseModalUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _multitrack.ga)('Membership Purchase', 'alc_shopping_fire_modal', this.props.schedule.id);
    }
  }, {
    key: 'renderFormattedPrice',
    value: function renderFormattedPrice(price, currencyCode) {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'em',
          null,
          _react2.default.createElement(_reactIntl.FormattedNumber, {
            id: 'calloutCard.callout.amount',
            currency: currencyCode,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            style: 'currency',
            value: price
          })
        )
      );
    }
  }, {
    key: 'renderOfferCardDetails',
    value: function renderOfferCardDetails() {
      var offer = this.props.offer;


      var creditsCount = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'calloutCard.details.creditsCount.creditsPerCycle',
        defaultMessage: '{creditsPerCycle} credits',
        tagName: 'strong',
        values: {
          creditsPerCycle: offer.initial_plan.credits_per_cycle
        }
      });

      var classesRange = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'calloutCard.details.creditsCount.classEstimate',
        defaultMessage: '{minClassEstimate} - {maxClassEstimate} classes',
        tagName: 'strong',
        values: {
          minClassEstimate: offer.initial_plan.min_class_estimate,
          maxClassEstimate: offer.initial_plan.max_class_estimate
        }
      });

      return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'calloutCard.details.creditsCount',
        defaultMessage: 'Includes {creditsCount} to book {classesRange}',
        values: {
          creditsCount: creditsCount,
          classesRange: classesRange
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _React$createElement;

      return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            { className: 'gamma color-background pt++ pb+ md-pv' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'modal.purchase.header',
              defaultMessage: 'Select a pricing option'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _CardSelection.CardSelection,
            {
              defaultSelected: OFFER_CARD,
              mobileCtaCopy: 'Select',
              onCardSelected: this.handleCardSelection
            },
            (_React$createElement = {}, (0, _defineProperty3.default)(_React$createElement, OFFER_CARD, this.renderOfferCard), (0, _defineProperty3.default)(_React$createElement, CLASS_CARD, this.renderClassCard), _React$createElement)
          )
        )
      );
    }
  }]);
  return PurchaseModalUnwrapped;
}(_react.Component);

PurchaseModalUnwrapped.propTypes = {
  hideModal: _propTypes2.default.func.isRequired,
  offer: _propTypes2.default.shape({
    content: _propTypes2.default.shape({
      card: _propTypes2.default.shape({
        cta_copy: _propTypes2.default.string,
        price_terms: _propTypes2.default.string.isRequired,
        tag: _propTypes2.default.string
      }).isRequired
    }).isRequired,
    initial_plan: _propTypes2.default.shape({
      price: _propTypes2.default.number.isRequired
    }).isRequired
  }),
  schedule: _propTypes2.default.shape({
    availability: _propTypes2.default.shape({
      purchase: _propTypes2.default.shape({
        amount: _propTypes2.default.number.isRequired
      }).isRequired
    }).isRequired,
    endtime: _propTypes2.default.number.isRequired,
    class: _propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired
    }).isRequired,
    id: _propTypes2.default.number.isRequired,
    starttime: _propTypes2.default.number.isRequired,
    venue: _propTypes2.default.shape({
      ratings: _propTypes2.default.shape({
        mean: _propTypes2.default.number
      }),
      name: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  updatePath: _propTypes2.default.func.isRequired
};

var PurchaseModal = exports.PurchaseModal = (0, _Modal2.default)({ headerClass: 'modal--background-light' })((0, _reactRedux.connect)(null, mapDispatchToProps)(PurchaseModalUnwrapped));